import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ANNOUNCEMENT_CATEGORY_LABELS,
  ANNOUNCEMENT_SEVERITY_LABELS,
} from '@df-gate-share/shared';
import { useAnnouncementsOptional } from '../contexts/AnnouncementContext';
import {
  CATEGORY_BADGE_CLASS,
  SEVERITY_BADGE_CLASS,
} from '../pages/announcementDisplay';

/**
 * お知らせバナー（Requirement 18.4）
 * ログイン後ホーム画面上部に常設。未読の公開中お知らせがある場合のみ表示し、
 * 未読件数＋最新お知らせのタイトル・カテゴリ・重要度バッジを含む。
 * クリックで /announcements へ遷移。全既読で非表示。
 * （ベルアイコンではなく、画面上部の目立つ帯として実装）
 */
const AnnouncementBanner: React.FC = () => {
  const navigate = useNavigate();
  const { unreadCount, latestUnread } = useAnnouncementsOptional();

  // 未読がない、または最新未読を特定できない場合は非表示。
  if (unreadCount <= 0 || !latestUnread) {
    return null;
  }

  const goToAnnouncements = () => navigate('/announcements');

  return (
    <div
      className="announcement-banner"
      role="button"
      tabIndex={0}
      aria-label="未読のお知らせがあります"
      onClick={goToAnnouncements}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          goToAnnouncements();
        }
      }}
    >
      <span className="material-symbols-outlined announcement-banner__icon">
        campaign
      </span>
      <div className="announcement-banner__body">
        <div className="announcement-banner__label">
          未読のお知らせ {unreadCount}件
        </div>
        <div className="announcement-banner__title">
          <span
            className={`badge ${SEVERITY_BADGE_CLASS[latestUnread.severity]}`}
          >
            {ANNOUNCEMENT_SEVERITY_LABELS[latestUnread.severity]}
          </span>
          <span
            className={`badge ${CATEGORY_BADGE_CLASS[latestUnread.category]}`}
          >
            {ANNOUNCEMENT_CATEGORY_LABELS[latestUnread.category]}
          </span>
          <span className="announcement-banner__title-text">
            {latestUnread.title}
          </span>
        </div>
      </div>
      <span className="announcement-banner__cta">お知らせを見る →</span>
    </div>
  );
};

export default AnnouncementBanner;
